// @ts-strict-ignore
import React from 'react';
import { Card } from '@usealloy/component-library';

import { ServicesListNew } from '~/entities/evaluations/service/ServicesListNew';

import { useEventTypeEvaluationsContext } from '../context';

const DataSources: React.FC = () => {
  const { evaluation } = useEventTypeEvaluationsContext();

  return (
    <Card
      header="Data Sources"
      collapsible
    >
      <ServicesListNew
        evaluationToken={evaluation.evaluation_token}
        // @ts-ignore
        finalResponse={evaluation?.final_response}
      />
    </Card>
  );
};

export default DataSources;
